// extracted by mini-css-extract-plugin
export default {"notesContainer":"Notes_notesContainer__ycVD+","notesLabel":"Notes_notesLabel__8B4Pl","notesTextArea":"Notes_notesTextArea__ccwwT"};